import { useServiceWorker } from '@/hooks/useServiceWorker'

export function UpdateNotification() {
  const { needRefresh, updateServiceWorker, close } = useServiceWorker()

  if (!needRefresh) {
    return null
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50">
      <div className="bg-primary-600 text-white rounded-lg shadow-lg p-4 flex items-center justify-between">
        <div className="flex-1">
          <p className="font-medium">A new version is available</p>
          <p className="text-sm text-primary-100">Click update to get the latest features.</p>
        </div>
        <div className="flex gap-2 ml-4">
          <button
            onClick={close}
            className="px-3 py-1.5 text-sm text-primary-200 hover:text-white transition-colors"
          >
            Dismiss
          </button>
          <button
            onClick={updateServiceWorker}
            className="px-3 py-1.5 text-sm bg-white text-primary-600 rounded font-medium hover:bg-primary-50 transition-colors"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  )
}
